// extracted by mini-css-extract-plugin
export var amountPaidColumn = "_j6-6";
export var emphasizeQuantity = "_j6-3";
export var flatBottomCorners = "_j6-5";
export var productImage = "_j6-0";
export var quantityContainer = "_j6-2";
export var tooltip = "_j6-1";
export var wrapAndEllipsesOverflow = "_j6-4";